// frontend/src/components/sidebar/NavigationItem.jsx
import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { ChevronDown, ChevronRight } from 'lucide-react'

const NavigationItem = ({ 
  icon: Icon, 
  label, 
  description, 
  isActive, 
  onClick, 
  badge,
  hasSubItems = false
}) => {
  const [isExpanded, setIsExpanded] = useState(isActive)

  const handleClick = () => {
    if (hasSubItems) {
      setIsExpanded(!isExpanded)
    }
    onClick?.()
  }

  return (
    <motion.button
      whileHover={{ x: 4 }}
      onClick={handleClick}
      className={`w-full flex items-center space-x-3 px-3 py-3 rounded-lg transition-colors text-left ${
        isActive
          ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-600'
          : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
      }`}
    >
      <Icon className="h-5 w-5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{label}</p>
        {description && (
          <p className="text-xs text-gray-500 truncate">
            {description}
          </p>
        )}
      </div>
      
      {/* Badge */}
      {badge && (
        <span className="bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-medium">
          {badge}
        </span>
      )}
      
      {/* Expand/Collapse Icon */}
      {hasSubItems && (
        <motion.div
          animate={{ rotate: isExpanded ? 90 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <ChevronRight className="h-4 w-4 text-gray-400" />
        </motion.div>
      )}
    </motion.button>
  )
}

export default NavigationItem